import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CheckboxComponent } from "./checkbox/checkbox.component";
import { FormsModule } from "@angular/forms";
import { InputComponent } from "./input/input.component";
import { ColorDirective } from "./directives/color.directive";
import { StateDirective } from "./directives/state.directive";
import { FocusDirective } from "src/components/directives/focus.directive";
import { RouterModule } from "@angular/router";
import { TabsComponent } from "./tabs/tabs.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { PictureSelectorComponent } from "./picture-selector/picture-selector.component";
import { BarcodeScannerLivestreamModule } from "ngx-barcode-scanner";

const Components: any[] = [
  CheckboxComponent,
  InputComponent,
  ColorDirective,
  StateDirective,
  FocusDirective,
  PictureSelectorComponent,
  TabsComponent,
  NotFoundComponent,
];

@NgModule({
  declarations: Components,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild([]),
    BarcodeScannerLivestreamModule,
  ],
  exports: Components,
})
export class ComponentsModule {}
